const clientConfig = {
	siteUrl: 'https://faculty-preobarding.de.r.appspot.com',
	// siteUrl :'http://localhost:5001'
};

export default clientConfig;